namespace $ { export class $piterjs_app extends $mol_view {

	/**
	 *  ```
	 *  plugins / <= Theme
	 *  ```
	 **/
	plugins() {
		return [this.Theme()] as readonly any[]
	}

	/**
	 *  ```
	 *  Theme $mol_theme_auto
	 *  ```
	 **/
	@ $mol_mem
	Theme() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_theme_auto(  ) )
	}

	/**
	 *  ```
	 *  sub / <= Screen
	 *  ```
	 **/
	sub() {
		return [this.Screen()] as readonly any[]
	}

	/**
	 *  ```
	 *  Screen $piterjs_screen
	 *  	place <= place
	 *  	Open null
	 *  	Close null
	 *  	content / <= Book
	 *  ```
	 **/
	@ $mol_mem
	Screen() {
		return (( obj )=>{
			obj.place = () => this.place()
			obj.Open = () => null as any
			obj.Close = () => null as any
			obj.content = () => [this.Book()] as readonly any[]
			return obj
		})( new this.$.$piterjs_screen(  ) )
	}

	/**
	 *  ```
	 *  place $piterjs_place
	 *  ```
	 **/
	@ $mol_mem
	place() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_place(  ) )
	}

	/**
	 *  ```
	 *  Book $mol_book2 pages <= pages
	 *  ```
	 **/
	@ $mol_mem
	Book() {
		return (( obj )=>{
			obj.pages = () => this.pages()
			return obj
		})( new this.$.$mol_book2(  ) )
	}

	/**
	 *  ```
	 *  pages /any
	 *  ```
	 **/
	pages() {
		return [] as readonly ( any )[]
	}

	/**
	 *  ```
	 *  toggle_intro?val false
	 *  ```
	 **/
	@ $mol_mem
	toggle_intro( val? : any , force? : $mol_mem_force ) {
		return ( val !== void 0 ) ? val : false
	}

	/**
	 *  ```
	 *  Menu $mol_page
	 *  	title \Митапы
	 *  	body /
	 *  		<= Meetups
	 *  		<= Links
	 *  ```
	 **/
	@ $mol_mem
	Menu() {
		return (( obj )=>{
			obj.title = () => "Митапы"
			obj.body = () => [this.Meetups() , this.Links()] as readonly any[]
			return obj
		})( new this.$.$mol_page(  ) )
	}

	/**
	 *  ```
	 *  Meetups $mol_list rows <= menu_meetups
	 *  ```
	 **/
	@ $mol_mem
	Meetups() {
		return (( obj )=>{
			obj.rows = () => this.menu_meetups()
			return obj
		})( new this.$.$mol_list(  ) )
	}

	/**
	 *  ```
	 *  menu_meetups /
	 *  ```
	 **/
	menu_meetups() {
		return [] as readonly any[]
	}

	/**
	 *  ```
	 *  Links $mol_list rows /
	 *  	<= Conf
	 *  	<= Others_link
	 *  ```
	 **/
	@ $mol_mem
	Links() {
		return (( obj )=>{
			obj.rows = () => [this.Conf() , this.Others_link()] as readonly any[]
			return obj
		})( new this.$.$mol_list(  ) )
	}

	/**
	 *  ```
	 *  Conf $mol_link
	 *  	uri \https://conf.piterjs.org/
	 *  	sub /
	 *  		<= Conf_title
	 *  		<= Conf_date
	 *  ```
	 **/
	@ $mol_mem
	Conf() {
		return (( obj )=>{
			obj.uri = () => "https://conf.piterjs.org/"
			obj.sub = () => [this.Conf_title() , this.Conf_date()] as readonly any[]
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  Conf_title $mol_view sub / \Conf
	 *  ```
	 **/
	@ $mol_mem
	Conf_title() {
		return (( obj )=>{
			obj.sub = () => ["Conf"] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  Conf_date $mol_view sub / \сентябрь'19
	 *  ```
	 **/
	@ $mol_mem
	Conf_date() {
		return (( obj )=>{
			obj.sub = () => ["сентябрь'19"] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  Others_link $mol_link
	 *  	uri \#others
	 *  	title \Другие события
	 *  ```
	 **/
	@ $mol_mem
	Others_link() {
		return (( obj )=>{
			obj.uri = () => "#others"
			obj.title = () => "Другие события"
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  Meetup!id $piterjs_meetup_page meetup <= meetup!id
	 *  ```
	 **/
	@ $mol_mem_key
	Meetup( id : any ) {
		return (( obj )=>{
			obj.meetup = () => this.meetup(id)
			return obj
		})( new this.$.$piterjs_meetup_page(  ) )
	}

	/**
	 *  ```
	 *  meetup!id $piterjs_meetup
	 *  ```
	 **/
	@ $mol_mem_key
	meetup( id : any ) {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_meetup(  ) )
	}

	/**
	 *  ```
	 *  Speech!id $piterjs_speech_page speech <= speech!id
	 *  ```
	 **/
	@ $mol_mem_key
	Speech( id : any ) {
		return (( obj )=>{
			obj.speech = () => this.speech(id)
			return obj
		})( new this.$.$piterjs_speech_page(  ) )
	}

	/**
	 *  ```
	 *  speech!id $piterjs_speech
	 *  ```
	 **/
	@ $mol_mem_key
	speech( id : any ) {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_speech(  ) )
	}

	/**
	 *  ```
	 *  Menu_meetup!id $piterjs_meetup_snippet meetup <= meetup!id
	 *  ```
	 **/
	@ $mol_mem_key
	Menu_meetup( id : any ) {
		return (( obj )=>{
			obj.meetup = () => this.meetup(id)
			return obj
		})( new this.$.$piterjs_meetup_snippet(  ) )
	}

	/**
	 *  ```
	 *  Now $piterjs_now place <= place
	 *  ```
	 **/
	@ $mol_mem
	Now() {
		return (( obj )=>{
			obj.place = () => this.place()
			return obj
		})( new this.$.$piterjs_now(  ) )
	}

	/**
	 *  ```
	 *  Intro $piterjs_intro
	 *  	meetup <= meetup_current
	 *  	page?val <=> intro?val
	 *  ```
	 **/
	@ $mol_mem
	Intro() {
		return (( obj )=>{
			obj.meetup = () => this.meetup_current()
			obj.page = ( val? : any ) => this.intro( val )
			return obj
		})( new this.$.$piterjs_intro(  ) )
	}

	/**
	 *  ```
	 *  meetup_current $piterjs_meetup
	 *  ```
	 **/
	@ $mol_mem
	meetup_current() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_meetup(  ) )
	}

	/**
	 *  ```
	 *  intro?val \
	 *  ```
	 **/
	@ $mol_mem
	intro( val? : any , force? : $mol_mem_force ) {
		return ( val !== void 0 ) ? val : ""
	}

	/**
	 *  ```
	 *  Video $piterjs_video_page source <= video_uri
	 *  ```
	 **/
	@ $mol_mem
	Video() {
		return (( obj )=>{
			obj.source = () => this.video_uri()
			return obj
		})( new this.$.$piterjs_video_page(  ) )
	}

	/**
	 *  ```
	 *  video_uri \
	 *  ```
	 **/
	video_uri() {
		return ""
	}

	/**
	 *  ```
	 *  Place $piterjs_place_page place <= place
	 *  ```
	 **/
	@ $mol_mem
	Place() {
		return (( obj )=>{
			obj.place = () => this.place()
			return obj
		})( new this.$.$piterjs_place_page(  ) )
	}

	/**
	 *  ```
	 *  Others $piterjs_others
	 *  ```
	 **/
	@ $mol_mem
	Others() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_others(  ) )
	}

} }
